import { IArchiveI9Repository } from '../../application/ports/outbound/IArchiveI9Repository';
import { HttpClient } from '../http/HttpClient';

export class ApiArchiveI9Repository implements IArchiveI9Repository {
  constructor(private httpClient: HttpClient) {}

  async archive(i9FormId: string, reason: string): Promise<string> {
    const response = await this.httpClient.delete<string>(`/i9Form/${i9FormId}/archive`, {
      data: { archiveReason: reason },
    });
    return response.data ?? 'I-9 form archived successfully';
  }
}
